import { SATIS_UI as S } from './metin/satis-ui';
import { kirilimSatirlari, type TutarKirilimi } from './teklif-kirilim';

/**
 * Tutar kırılımı, ekran sunumu: ürün fiyatı (KDV hariç), ek ücret, indirim, KDV (oran başına), devlet harcı,
 * yuvarlama, genel toplam. Taslak ve kayıtlı teklif aynı bileşeni kullanır; satır sırası sunucudaki PDF ve
 * mesajla aynıdır. Sıfır satırlar gösterilmez.
 */
export function TutarKirilimiListesi({ kirilim, para, testId }: { kirilim: TutarKirilimi; para: (minor: number) => string; testId: string }) {
  return (
    <dl className="sales-price-summary" data-testid={testId}>
      {kirilimSatirlari(kirilim, S.kirilim).map((satir, index) => (
        <div key={`${satir.tur}-${index}`} data-testid={`kirilim-${satir.tur}`} className={satir.tur === 'toplam' ? 'sales-total' : undefined}>
          <dt>{satir.etiket}</dt>
          <dd>{satir.minor < 0 ? `-${para(-satir.minor)}` : para(satir.minor)}</dd>
        </div>
      ))}
    </dl>
  );
}
